import React, { Component } from 'react';
import { setTimeout, clearTimeout } from 'timers';

export default (WrappedComponent) => {
    return class Timeout extends Component {
        constructor(props) {
            super(props);   
        }

        setTimeout() {
            this.timeouts.push(setTimeout.apply(null, arguments));
        }

        clearTimeouts() {
            this.timeouts.forEach(clearTimeout);
        }

        componentWillMount() {
            this.timeouts = [];
        }

        componentWillUnmount() {
            this.clearTimeouts();
        }

        render() {
            const { timeouts, setTimeout, clearTimeouts } = this;
            return <WrappedComponent timeouts={timeouts} setTimeout={setTimeout} clearTimeouts={clearTimeouts} {...this.props} />;
        }
    }; 
};


// WEBPACK FOOTER //
// ./src/common/progress/withTimeout.js